import { useContext } from 'react';
import { Route, Switch } from 'react-router';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { SidebarLayout } from '@treams/treams-ui/common/SidebarLayout';

import { ModalContext } from '../../navigation/ModalNavigation';
import GrowthPathSidebar from '../components/GrowthPathSidebar';
import GrowthPathContextProvider from '../contexts/GrowthPathContext';
import CareerDetail from '../views/CareerDetail';
import JobTitleDetail from '../views/JobTitleDetail';
import MyJobTitleDetail from '../views/MyJobTitlesDetail';
import GrowthPathCompetencyDetail from './GrowthPathCompetencyDetail';

export const GrowthPathDetailContainer = styled(Flex)`
	flex-direction: column;
`;

const GrowthPathV2Routes = () => {
	const { isModal } = useContext(ModalContext);
	const routes = (
		<Switch>
			<Route
				path={[
					'/users/:userID/growth-path/my-job-title/:jobTitleID/competency/:competencyID',
					'/users/:userID/growth-path/career/:careerID/job-title/:jobTitleID/competency/:competencyID',
					'/users/:userID/growth-path/job-title/:jobTitleID/competency/:competencyID',
					'/growth-path/my-job-title/:jobTitleID/competency/:competencyID',
					'/growth-path/career/:careerID/job-title/:jobTitleID/competency/:competencyID',
					'/growth-path/job-title/:jobTitleID/competency/:competencyID',
				]}
			>
				<GrowthPathCompetencyDetail />
			</Route>

			<Route
				path={[
					'/users/:userID/growth-path/my-job-title/:jobTitleID',
					'/growth-path/my-job-title/:jobTitleID',
				]}
			>
				<MyJobTitleDetail />
			</Route>
			<Route
				path={[
					'/users/:userID/growth-path/career/:careerID/job-title/:jobTitleID',
					'/growth-path/career/:careerID/job-title/:jobTitleID',
				]}
			>
				<CareerDetail />
			</Route>
			<Route
				path={['/users/:userID/growth-path/career/:careerID', '/growth-path/career/:careerID']}
			>
				<CareerDetail />
			</Route>
			<Route
				path={[
					'/users/:userID/growth-path/job-title/:jobTitleID',
					'/growth-path/job-title/:jobTitleID',
				]}
			>
				<JobTitleDetail />
			</Route>
		</Switch>
	);

	return (
		<GrowthPathContextProvider>
			{isModal ? routes : <SidebarLayout sidebar={<GrowthPathSidebar />}>{routes}</SidebarLayout>}
		</GrowthPathContextProvider>
	);
};

const GrowthPath = () => {
	return <GrowthPathV2Routes />;
};

export default GrowthPath;
